import { Injectable } from '@angular/core'

import * as firebase from 'firebase'

@Injectable()
export class FirebaseService {

  private root = ''

  constructor() { }

  public setRoot(path: string) {
    this.root = path
  }

  public getRef(path?: string): firebase.database.Reference {
    return firebase.database().ref(this.root).child(path)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/firebase/firebase.service.ts